import ajax from '@/lib/ajax.js';
function fetch(config) {
    if(config&&config.id){
        return ajax.get(`/api/table/${config.id}`).then(data=>{
            if(Error.isError(data)){
                throw data
            }else{
                return JSON.parse(data.result.data);
            }
        })
    }else{
        return Promise.resolve(config);
    }
}

function update(data) {
    return ajax.put(`/api/table/`, data).then(resp=>{
        return resp.result;
    });
}

function create(data) {
    return ajax.post(`/api/table/`, data).then(resp=>{
        return resp.result;
    });
}

function remove(config){
    if(config&&config.id){
        return ajax.delete(`/api/table/${config.id}`).then(data=>{
            if(Error.isError(data)){
                throw data
            }else{
                return data.result;
            }
        })
    }else{
        return Promise.resolve();
    }
}

export {fetch, update, create, remove}